import {action} from "mobx";
import integratorService from "../services/integratorService";
import appStore from "./appStore";

class IntegratorStore {
    @action integratorList = async (params) => {
        try {
            const response = await integratorService.integratorList(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching integrator list:", error);
            return [];
        }
    };

    @action integratorInfo = async (params) => {
        try {
            const response = await integratorService.integratorInfo(params);
            return response.data?.data;
        } catch (error) {
            console.error("Error fetching integrator list:", error);
            return [];
        }
    };

    @action updateIntegrator = async (params) => {
        try {
            const response = await integratorService.updateIntegrator(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching integrator list:", error);
            return [];
        }
    };

    @action createIntegrator = async (params) => {
        try {
            const response = await integratorService.createIntegrator(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            console.error("Error fetching integrator list:", error);
            return false;
        }
    };

    @action deleteIntegrator = async (params) => {
        try {
            const response = await integratorService.deleteIntegrator(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return true;
        } catch (error) {
            console.error("Error fetching integrator list:", error);
            return [];
        }
    };

    @action patchIntegrator = async (params) => {
        try {
            const response = await integratorService.patchIntegrator(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching integrator list:", error);
            return [];
        }
    };
}

export default new IntegratorStore();
